import React from "react";
import {NavLink } from "react-router-dom";

function FeaturedArtist(props) {
    return (    <div className={props.classList}>
    <div className="tp-img">
      <img src={props.coverImgSrc} alt="" />
    </div>

    {/* Artists Content */}
    <div className="artists-content text-center">
      <div className="user-avatar">
        <img src={props.profileImgSrc} alt="" />
      </div>

      <h5 className="text-white">{props.authorName}</h5>
      <NavLink to="" className="btn btn-follow">
        + Follow
      </NavLink>
    </div>
    {/* End Artists Content */}
  </div> );
}

export default FeaturedArtist;